import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "../../../../../../components/loading/button";
import { setIsButtonLoading } from "../../../../../../store/slices/loadingSlice";
import axios from "axios";
import { node_server } from "../../../../../../constants";
import { updatePopup } from "../../../../../../store/slices/infoSlice";

const CreatorType = () => {
  const { theme } = useTheme();
  const [details, setDetails] = useState("");
  const { buttonLoading } = useSelector((state) => state.isLoading);
  const [isDisabled, setIsdisabled] = useState(true);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    dispatch(setIsButtonLoading(true));
    const { data, error } = await axios.post(
      `${node_server}/api/feedback/tickets`,
      {
        category: "Help With Classification",
        details,
        key: "HWC",
      },
      {
        withCredentials: true,
      }
    );
    if (error) console.log(error);
    if (data) {
      dispatch(updatePopup({ isOpen: true }));
      dispatch(setIsButtonLoading(false));
    }
  };

  useEffect(() => {
    if (details.length > 0) {
      setIsdisabled(false);
    } else {
      setIsdisabled(true);
    }
  }, [buttonLoading, details]);

  return (
    <Box className={styles.creatorType}>
      <Box className={styles.content}>
        <Box className={styles.creatorType2}>
          <Typography
            variant="h4"
            sx={{
              color: theme.palette.darkgrey.darkgrey600,
              fontSize: "20px",
              fontWeight: "500",
            }}
          >
            Details
          </Typography>
        </Box>
        <Box className={styles.options}>
          <Typography
            variant="body1"
            color={theme.palette.darkgrey.darkgrey600}
          >
            Give us a short description of what skill you are looking for in our
            list...
          </Typography>

          <TextField
            sx={{
              background: theme.palette.lightgrey.lightgrey00,
            }}
            fullWidth
            id="outlined-textarea"
            multiline
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            rows={4}
          />
        </Box>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={buttonLoading || isDisabled}
          fullWidth
        >
          {buttonLoading ? <LoadingButton /> : "Submit"}
        </Button>
      </Box>
    </Box>
  );
};

export default CreatorType;
